export default (that) => [
  {
    field: 'seq',
    width: 80,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('table_label_dateRange') || '日期',
    field: 'orderDate',
    width: 130,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    treeNode: true,
    fixed: 'left',
  },
  {
    title: that.$l('INDEX.type') || '类型',
    field: 'type',
    width: 90,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_regionName') || '市场',
    field: 'regionName',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_storeName') || '门店',
    field: 'storeName',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.SKU') || 'SKU',
    field: 'amzSkuNo',
    width: 180,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_itemDesc') || '产品描述',
    field: 'itemDesc',
    headerAlign: 'center',
    align: 'center',
    minWidth: 400,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_quantity') || '销售',
    field: 'quantity',
    width: 90,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
  },
  {
    title: that.$l('table_label_avgQtyPerDay') || '日销',
    field: 'avgQtyPerDay',
    width: 90,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
  },
  {
    title: that.$l('table_label_RMB') || '人民币',
    field: 'productSalesCNY',
    width: 110,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_USD') || '美元',
    field: 'productSalesUSD',
    width: 110,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_productSales') || '金额',
    field: 'productSales',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
  },
  {
    title: that.$l('table_label_currency') || '币种',
    field: 'currency',
    width: 80,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_unitCbm') || '单品体积',
    field: 'unitVolume',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_volume') || '体积',
    field: 'volume',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
  },
]
